var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColourReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 62.479 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    transform: "translate(-1.682 -4.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M23.7,20.176a.708.708,0,0,0-.964.273,4.7,4.7,0,0,0-.591,2.287,4.77,4.77,0,0,0,.591,2.311.713.713,0,0,0,.62.364.681.681,0,0,0,.345-.092.709.709,0,0,0,.275-.964,3.326,3.326,0,0,1-.412-1.619,3.278,3.278,0,0,1,.412-1.595.708.708,0,0,0-.275-.964Z",
    transform: "translate(24.185 18.098)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6001",
    "data-name": "Path 6001",
    d: "M41.025,34.433l-4.957-4.959a8.287,8.287,0,1,0-3.508,3.506l4.959,4.959a2.479,2.479,0,1,0,3.506-3.506ZM24.043,30.519a6.764,6.764,0,1,1,9.565,0,6.924,6.924,0,0,1-9.565,0Zm10.569,1a8.3,8.3,0,0,0,.676-.823l.7.7-1.5,1.5-.7-.7a8.406,8.406,0,0,0,.825-.679Zm5.411,5.413a1.067,1.067,0,0,1-1.5,0L35.5,33.909l1.5-1.5,3.026,3.026A1.065,1.065,0,0,1,40.023,36.936Z",
    transform: "translate(22.411 15.108)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6002",
    "data-name": "Path 6002",
    d: "M55.214,4.771H3.482a1.781,1.781,0,0,0-1.8,1.8V45.692a1.8,1.8,0,0,0,1.8,1.8H42.3a.709.709,0,0,0,0-1.418H3.482a.381.381,0,0,1-.382-.382V15H55.6V31.357a.709.709,0,0,0,1.418,0V6.571a1.8,1.8,0,0,0-1.8-1.8ZM3.1,13.577V6.571a.373.373,0,0,1,.382-.382H55.214a.387.387,0,0,1,.382.382v7.006Z",
    transform: "translate(0)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6003",
    "data-name": "Path 6003",
    d: "M7.229,6.621A1.073,1.073,0,1,0,8.3,7.694,1.073,1.073,0,0,0,7.229,6.621Z",
    transform: "translate(5.288 2.186)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 1.073,
    cy: 1.073,
    r: 1.073,
    transform: "translate(6.945 8.807)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 1.073,
    cy: 1.073,
    r: 1.073,
    transform: "translate(15.945 8.807)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6004",
    "data-name": "Path 6004",
    d: "M9.519,10.55H8.282a.709.709,0,0,0,0,1.418H9.517a.709.709,0,0,0,0-1.418Z",
    transform: "translate(6.962 6.83)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6005",
    "data-name": "Path 6005",
    d: "M4.377,11.97h5.834a.71.71,0,0,0,0-1.42H4.377a.71.71,0,0,0,0,1.42Z",
    transform: "translate(2.347 6.83)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6006",
    "data-name": "Path 6006",
    d: "M11.973,12.146H6.206a.709.709,0,1,0,0,1.418h5.767a.709.709,0,1,0,0-1.418Z",
    transform: "translate(4.509 8.716)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M4.377,13.564h1.3a.709.709,0,1,0,0-1.418h-1.3a.709.709,0,1,0,0,1.418Z",
    transform: "translate(2.347 8.716)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M4.377,15.159h9.757a.709.709,0,1,0,0-1.418H4.377a.709.709,0,0,0,0,1.418Z",
    transform: "translate(2.347 10.601)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M31.034,25.016a1.3,1.3,0,0,0,.82-1.211V21.643a1.3,1.3,0,0,0-.82-1.213L29.5,19.856a5.765,5.765,0,0,0-.6-1.37l.679-1.584a1.293,1.293,0,0,0-.279-1.436l-1.527-1.529a1.3,1.3,0,0,0-1.436-.277l-1.49.676a5.753,5.753,0,0,0-1.4-.535L22.8,12.2a1.3,1.3,0,0,0-1.211-.818H19.427a1.3,1.3,0,0,0-1.213.82l-.574,1.532a5.965,5.965,0,0,0-1.372.607l-1.584-.676a1.294,1.294,0,0,0-1.436.277L11.72,15.464a1.3,1.3,0,0,0-.279,1.438l.676,1.49a5.807,5.807,0,0,0-.535,1.4l-1.6.641a1.3,1.3,0,0,0-.82,1.213V23.8a1.3,1.3,0,0,0,.82,1.211l1.534.576a5.863,5.863,0,0,0,.6,1.37l-.679,1.584a1.293,1.293,0,0,0,.279,1.436l1.527,1.532a1.307,1.307,0,0,0,1.436.275l1.49-.676a5.832,5.832,0,0,0,1.4.535l.641,1.6a1.306,1.306,0,0,0,1.213.818h2.162a1.3,1.3,0,0,0,1.213-.82l.574-1.532a5.933,5.933,0,0,0,1.372-.607l1.586.679a1.306,1.306,0,0,0,1.433-.279L29.3,29.982a1.3,1.3,0,0,0,.279-1.438l-.676-1.49a5.924,5.924,0,0,0,.535-1.4Zm-2.887.148a8.477,8.477,0,0,1-.511,1.241,1.291,1.291,0,0,0-.046,1.115l.7,1.46-1.405,1.5L25.3,29.805a1.311,1.311,0,0,0-1.111.046,7.955,7.955,0,0,1-1.246.513,1.293,1.293,0,0,0-.82.757l-.537,1.529-2.058.072-.641-1.6a1.3,1.3,0,0,0-.823-.759,7.931,7.931,0,0,1-1.244-.513,1.329,1.329,0,0,0-.6-.148,1.312,1.312,0,0,0-.506.1l-1.46.7-1.5-1.405.679-1.584a1.283,1.283,0,0,0-.046-1.108,7.994,7.994,0,0,1-.511-1.246,1.307,1.307,0,0,0-.757-.823L10.581,23.8l-.074-2.055,1.6-.644a1.3,1.3,0,0,0,.753-.818,8.577,8.577,0,0,1,.511-1.241,1.3,1.3,0,0,0,.046-1.117l-.7-1.46,1.405-1.5,1.586.679a1.3,1.3,0,0,0,1.111-.046,8.015,8.015,0,0,1,1.246-.515,1.3,1.3,0,0,0,.82-.755l.537-1.529,2.058-.072.641,1.6a1.292,1.292,0,0,0,.823.757,8.2,8.2,0,0,1,1.244.513,1.3,1.3,0,0,0,1.113.044l1.46-.7,1.5,1.405-.679,1.584a1.287,1.287,0,0,0,.046,1.111,7.993,7.993,0,0,1,.511,1.246,1.312,1.312,0,0,0,.757.823l1.532.539v2.086l-1.529.613a1.286,1.286,0,0,0-.755.818Z",
    transform: "translate(8.839 7.807)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M17.064,14.291a4.99,4.99,0,1,0,4.988,4.99,5,5,0,0,0-4.988-4.99Zm0,8.559a3.57,3.57,0,1,1,3.57-3.57A3.576,3.576,0,0,1,17.064,22.85Z",
    transform: "translate(12.282 11.251)",
    fill: "#f48116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourReports);
export default __webpack_public_path__ + "static/media/ColourReports.dae0dbc74b94ee52110e0b85ccc0f2ad.svg";
export { ForwardRef as ReactComponent };